import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
// PrimeNG modules
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
// Component
import { ProductoSelectBusquedaComponent } from './producto-select-busqueda.component';

@NgModule({
  declarations: [ProductoSelectBusquedaComponent],
  imports: [
    CommonModule,
    FormsModule,
    AutoCompleteModule,
    ProgressSpinnerModule,
  ],
  exports: [ProductoSelectBusquedaComponent],
})
export class ProductoSelectBusquedaModule {}
